import {useDebugValue} from 'react';

import classNames from 'classnames';
import {useSearchFormContext} from '../../../hooks/useSearchFormContext';
import {runCollapsedPDPSearchFormCTAv2Experiment} from '../../../utils/experiments';

const classNamespace = 'search-form';
const fieldsClassName = `${classNamespace}__fields`;
const summaryFieldsClassName = `${classNamespace}__summary-fields`;

function useComponent() {
    const className = classNames(fieldsClassName, summaryFieldsClassName);
    const {
        abacusStore
    } = useSearchFormContext();
    const isCollapsedPDPSearchFormCTAv2Experiment = runCollapsedPDPSearchFormCTAv2Experiment({shouldLogExperiment: true}, abacusStore);

    const result = {
        className,
        isCollapsedPDPSearchFormCTAv2Experiment
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
